var _path, _path2, _path3;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgCodeUploadFilled(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 29,
    viewBox: "0 0 40 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.65518 14.5077C0.49236 18.3202 0.027795 19.9297 0.00672668 20.2192C-0.0757334 21.3513 0.607516 22.5202 1.6398 23.013C1.98095 23.1758 4.49433 23.8591 12.2768 25.9048C17.8814 27.3781 22.6207 28.6228 22.8084 28.671C23.2064 28.773 23.9095 28.7828 24.3113 28.6919C25.0481 28.5251 25.8532 27.932 26.2051 27.2968C26.2971 27.1306 26.6546 26.1131 26.9995 25.0356C27.3444 23.9581 27.6421 23.0281 27.6611 22.969C27.6939 22.8669 27.1912 22.8615 17.7043 22.8611C7.97647 22.8606 7.69946 22.8574 7.19876 22.7395C5.36576 22.3077 4.0097 20.9898 3.47449 19.1201C3.34489 18.6674 3.34001 18.5148 3.30763 13.9265L3.27431 9.19922L1.65518 14.5077Z",
    fill: "var(--secondary-1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.55218 1.80759C5.98961 0.926041 6.88736 0.253164 7.88757 0.057272C8.02511 0.0303053 12.8077 0.00561148 18.5155 0.00241725C28.5513 -0.00320313 29.2504 -0.0200917 29.817 0.245555C29.8945 0.281858 29.9694 0.323437 30.0654 0.371043C30.8752 0.772718 31.6045 1.723 31.7943 2.62383C31.8419 2.84989 31.8626 5.25299 31.8619 10.4865C31.8611 17.6695 31.875 18.366 31.6074 18.9285C31.5643 19.0191 31.5139 19.1063 31.4549 19.2166C31.0804 19.9169 30.4187 20.4845 29.6411 20.7728L29.2684 20.9109L18.703 20.9271C11.4479 20.9383 8.03736 20.923 7.81755 20.8784C6.69837 20.6509 5.69022 19.7411 5.33781 18.6406L5.19934 18.208V10.4989C5.19934 3.23986 5.18666 2.59563 5.42531 2.06429C5.46151 1.98369 5.50349 1.90569 5.55218 1.80759ZM20.6636 4.03917L18.425 3.58962L16.3436 16.8888L18.5822 17.3384L20.6636 4.03917ZM29.092 10.4147L24.0504 5.35267L22.4377 6.97194L25.8665 10.4147L22.4377 13.8575L24.0504 15.4768L29.092 10.4147ZM14.6172 6.97194L13.0045 5.35267L7.96289 10.4147L13.0045 15.4768L14.6172 13.8575L11.1883 10.4147L14.6172 6.97194Z",
    fill: "var(--secondary-3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.599 28.0887C36.7409 28.0887 39.2879 25.5417 39.2879 22.3998C39.2879 19.2579 36.7409 16.7109 33.599 16.7109C30.4572 16.7109 27.9102 19.2579 27.9102 22.3998C27.9102 25.5417 30.4572 28.0887 33.599 28.0887ZM32.9324 25.9554V23.0665H30.0435V21.7331H32.9324V18.8443H34.2657V21.7331H37.1546V23.0665H34.2657V25.9554H32.9324Z",
    fill: "var(--secondary-7)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeUploadFilled);
export default __webpack_public_path__ + "static/media/codeUploadFilled.fdff80747cf1c0f0381c7b6fd2670216.svg";
export { ForwardRef as ReactComponent };